import { GiftCardProduct } from 'services/api';
import * as yup from 'yup';

import { FormLabelText } from './constants';

export const getGiftCardPurchaseFormSchema = ({
  useCsv,
  productValue,
  currencyCode
}: {
  useCsv: boolean;
  productValue: GiftCardProduct['value'];
  currencyCode: Configuration['currencyCode'];
}) => {
  return yup.object().shape({
    recipients: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string(),
          email: yup.string()
        })
      )
      .when(['distribute_myself'], {
        is: (distribute_myself: boolean) => !distribute_myself && !useCsv,
        then: yup.array().of(
          yup.object().shape({
            name: yup.string().required(FormLabelText.NAME_ERROR_TEXT),
            email: yup
              .string()
              .email('Invalid email')
              .required(FormLabelText.EMAIL_ERROR_TEXT)
          })
        )
      }),
    quantity: yup.number().when('distribute_myself', {
      is: true,
      then: yup
        .number()
        .moreThan(0, FormLabelText.NEGATIVE_VALUE_ERROR_TEXT)
        .required(FormLabelText.QUANTITY_ERROR_TEXT)
    }),
    value: yup
      .number()
      .nullable()
      .min(
        productValue.min,
        `${FormLabelText.MIN_VALUE_ERROR_TEXT} ${currencyCode} ${productValue.min}`
      )
      .max(
        productValue.max,
        `${FormLabelText.MAX_VALUE_ERROR_TEXT} ${currencyCode} ${productValue.max}`
      )
      .required(FormLabelText.GIFT_CARD_VALUE_ERROR_TEXT),
    distribute_myself: yup.boolean(),
    message: yup.string().when('distribute_myself', {
      is: false,
      then: yup
        .string()
        .required(FormLabelText.MESSAGE_ERROR_TEXT)
        .matches(
          /^[a-zA-Z0-9\s\-_/().,]+$/,
          'Invalid characters found in text - Only alphanumeric characters, spaces, hyphens, underscores, forward slashes, parentheses, periods and commas are allowed.'
        )
    })
  });
};
